module.exports = __webpack_public_path__ + "static/media/chatIcon.0f237e1c.svg";